import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import AxleComplaintsList from './AxleComplaintsList';
import AxleComplaintsShow from './AxleComplaintsShow';

export default {
    icon: ReportProblemIcon,
    list: AxleComplaintsList,
    show: AxleComplaintsShow
};
